/* Mon p'tit pitchou - protection legere contre la copie (images et textes) */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return; /* rien dans l'editeur de theme */

  var css =
    'img{-webkit-user-drag:none;user-drag:none;-webkit-touch-callout:none}' +
    'main p,main li,main h1,main h2,main h3,main td,main th,main .rte,main .description-produit{-webkit-user-select:none;user-select:none}' +
    'input,textarea,select,[contenteditable],.ligne-panier,.ligne-panier *{-webkit-user-select:text;user-select:text}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var champ = function (el) { return el && el.closest && el.closest('input,textarea,select,[contenteditable]'); };

  /* Clic droit / appui long : bloque sur les images et les textes du contenu, pas sur les liens ni les champs */
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (champ(t)) return;
    if (t.closest('img, picture') || (t.closest('main') && !t.closest('a'))) e.preventDefault();
  });

  /* Glisser-deposer des images */
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('img, picture')) e.preventDefault();
  });

  /* Copier (Ctrl+C) depuis le contenu de la page */
  document.addEventListener('copy', function (e) {
    if (champ(document.activeElement)) return;
    var sel = window.getSelection && window.getSelection();
    if (!sel || !sel.rangeCount) return;
    var n = sel.getRangeAt(0).commonAncestorContainer;
    if (n.nodeType !== 1) n = n.parentElement;
    if (n && n.closest('main')) e.preventDefault();
  });
})();
